const menuId = 'context-menu';
const baseStyle = {fontWeight: 600, fontSize: '14px'};

export {menuId, baseStyle};
